<div class="mainContainer mandala" *ngIf="getObjectKeys(liveActivitiesByDate).length !== 0">
  <div class="d-flex align-items-center w-100 Wrapper">
    <h2 class="headingBL title">Join Live<span> Classes</span></h2>
    <c-carousel
      class="carouselWrap w-100"
      [dark]="true"
      [interval]="-1"
      direction="prev"
    >
      <c-carousel-inner class="w-100 h-100 carouselInner">
        <c-carousel-item
          class="w-100 h-100"
          *ngFor="let key of getObjectKeys(liveActivitiesByDate)"
        >
          <div
            class="d-flex justify-content-around align-items-center w-100 activitWrap"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-start gap-1 info"
            >
              <div>
                <span style="color: var(--color-primary)">Day </span> :
                {{ getDayOfWeek(key) }}
              </div>
              <div>
                <span style="color: var(--color-primary)">Date </span> :
                {{ key }}
              </div>
            </div>
            <div class="d-flex flex-row align-items-center cardsWrap">
              <div *ngFor="let activity of liveActivitiesByDate[key]">
                <div (click)="openDialog()" class="liveCard position-relative">
                  <div class="imgWrap">
                    <img
                      loading="lazy"
                      class="cardImage"
                      [src]="activity.pic_urls"
                    />
                  </div>
                  <h4 class="book">Click to Book Now!</h4>
                  <div class="details">
                    <h3 class="vtext" style="color: var(--color-white)">
                      {{ activity.name }}
                    </h3>
                    <div>
                      {{ getTime(activity.event_datetime) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </c-carousel-item>
      </c-carousel-inner>
      <c-carousel-indicators class="indicator"></c-carousel-indicators>
      <c-carousel-control
        [routerLink]
        caption="Previous"
        direction="prev"
        class="navPrev"
      ></c-carousel-control>
      <c-carousel-control
        [routerLink]
        caption="Next"
        class="navNext"
        direction="next"
      ></c-carousel-control>
    </c-carousel>
  </div>
</div>
